export default "__VITE_ASSET__5Sbwd$xC__"